import styled from 'styled-components';

export const Bar = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  padding: 1.4rem 4rem;
  background: ${({ theme }) => theme.colors.background.invert};
  color: ${({ theme }) => theme.colors.grey[100]};

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 1.2rem;
    text-align: center;
  }

  p {
    font-family: ${({ theme }) => theme.fonts.familyUbuntu};
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
    letter-spacing: -0.54px;
    text-align: center;
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    margin: 0;
    color: ${({ theme }) => theme.colors.grey[100]};
    
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      margin-bottom: 1rem;
      font-size: ${({ theme }) => theme.fonts.sizes.small};
    }
  }
`;

export const CopyAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
  }
`;

export const InviterIcon = styled.img`
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.secondary.lighter};
  object-fit: cover;
  object-position: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const Username = styled.span`
  color: ${({ theme }) => theme.colors.primary.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: opacity 0.2s ease;
  color: ${({ theme }) => theme.colors.text.invert};

  svg {
    height: 2rem;
    width: 2rem;
  }

  &:hover {
    opacity: 1;
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    right: 1rem;
    top: 1rem;
  }
`;
